export function escapeHtml(value) {
	const str = String(value ?? '');
	return str
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
}

export function setAisSearchBoxAriaLabel(containerSelector, ariaLabel) {
	const input = document.querySelector(`${containerSelector} .ais-SearchBox-input`);
	if (input) {
		input.setAttribute('aria-label', ariaLabel);
	}
}

export function setHiddenSortSelectAriaLabel(ariaLabel = 'Sort results') {
	const select = document.querySelector('#hidden-sort-by select');
	if (select) {
		select.setAttribute('aria-label', ariaLabel);
	}
}

export function setAaInputAriaLabel(containerSelector, ariaLabel) {
	const input = document.querySelector(`${containerSelector} .aa-Input`);
	if (input) {
		input.setAttribute('aria-label', ariaLabel);
	}
}
